import script from "./number-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./number-widget-ly.vue?vue&type=script&setup=true&lang=js"

import "./number-widget-ly.vue?vue&type=style&index=0&id=50a38635&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a38635"]])

export default __exports__